import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAutoSize"><Path fillRule="evenodd" clipRule="evenodd" d="M20 2H4V22H20V2ZM6 11V4H18V20H13V11H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoSize;
